/**
 * Accepts a bare Lifeguard number ("12345678") or a full serial
 * ("DWLG-12345678"). Bare numbers get the environment prefix; full serials
 * are passed through trimmed (the API matches them case-insensitively).
 */
export const normalizeLifeguardSerial = (
  value: string,
  env: string | undefined = process.env.REACT_APP_ENV,
) => {
  const trimmed = value.trim();
  if (/^\d{1,8}$/.test(trimmed)) {
    const prefix = env === "production" ? "dwlg" : "dlgt";
    return `${prefix}-${trimmed}`;
  }
  return trimmed;
};
